import React from 'react';
import { IIllustrationProps } from './type';

const HeartDoodle: React.FC<IIllustrationProps> = ({
  width,
  height,
  color: _color = '#000',
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      width={width || 64}
      height={height || 64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M29.2805 24.4143C31.1616 22.3287 32.8792 20.3657 34.7195 18.5664C35.8236 17.5031 37.0913 16.6034 38.3591 15.7855C39.2588 15.1721 40.3629 14.9676 41.3853 15.5811C42.4485 16.2354 42.4894 17.3395 42.4076 18.4028C42.2032 20.2839 41.5489 22.0015 40.4447 23.4737C37.7457 27.0315 35.0466 30.5485 32.3067 34.0245C30.0984 36.8871 27.8083 39.668 25.5591 42.4897C25.3955 42.6942 25.2728 42.8986 25.1501 43.0622C24.3322 43.921 23.4734 43.7574 23.1463 42.6533C22.9418 41.8763 23.1054 41.0175 22.9418 40.2405C22.0012 35.2105 21.0607 30.1395 20.0383 25.1095C19.0568 20.2022 18.7706 15.2539 19.5476 10.3057C19.7111 9.3242 20.1201 8.38362 20.6517 7.52484C21.5105 6.05263 23.3099 5.80726 24.3731 7.11589C25.4773 8.46541 26.4179 10.0194 27.0313 11.6552C28.5853 15.7037 29.1578 19.9977 29.2805 24.4143Z"
        fill="#FA553D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.246 39.9121C46.3145 40.722 45.7134 41.4341 44.9035 41.5025C39.6234 41.9487 36.3774 44.5983 34.2415 47.7998C32.0624 51.066 31.0575 54.8837 30.3805 57.5712C30.1819 58.3595 29.382 58.8375 28.5938 58.6389C27.8056 58.4403 27.3276 57.6404 27.5262 56.8522C28.1987 54.1826 29.2998 49.9032 31.7929 46.1662C34.3293 42.3645 38.3216 39.1048 44.6556 38.5695C45.4655 38.501 46.1776 39.1021 46.246 39.9121Z"
        fill="black"
      />
    </svg>
  );
};

export default HeartDoodle;
